import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from "@angular/core";
import { PhxAddonWrapperSize } from "./phx-addon-wrapper.type";
import { PHX_SIZE } from "../../constants";

@Component({
  selector: 'phx-addon-wrapper',
  templateUrl: './phx-addon-wrapper.component.html',
  styleUrls: ['./phx-addon-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-addon-wrapper',
    '[class.phx-has-prefix]': '!!phxPrefixTemplate',
    '[class.phx-has-suffix]': '!!phxSuffixTemplate',
    '[class.phx-show-border]': 'phxShowBorder',
    '[class.phx-size-extra-small]': 'phxSize === PHX_SIZE.XS',
    '[class.phx-size-small]': 'phxSize === PHX_SIZE.SM',
    '[class.phx-size-medium]': 'phxSize === PHX_SIZE.MD',
    '[class.phx-size-large]': 'phxSize === PHX_SIZE.LG',
    '[class.phx-full-width]': 'phxFullWidth',
  }
})
export class PhxAddonWrapperComponent {
  @Input() phxPrefixTemplate: TemplateRef<any>;
  @Input() phxSuffixTemplate: TemplateRef<any>;
  @Input() phxShowBorder: boolean = true;
  @Input() phxSize: PhxAddonWrapperSize = PHX_SIZE.MD;
  @Input() phxFullWidth: boolean = false;
  public readonly PHX_SIZE = PHX_SIZE;
}